import { createRoot } from 'react-dom/client';
import { Basket } from './basket/basket';
import { ErrorBoundaryProvider } from 'basket/ErrorBoundary';

const domNode = document.getElementById('shopping-cart');
if (domNode) {
    const root = createRoot(domNode);

    const showBasket = domNode.dataset.showBasket;
    const itemsCount = parseInt(domNode.dataset.itemsCount, 10);
    const showText = domNode.dataset.showText;
    const scrollToBottom = domNode.dataset.scrollToBottom === 'true';

    root.render(<ErrorBoundaryProvider><Basket showBasket={showBasket} itemsCount={itemsCount} showText={showText} scrollToBottom={scrollToBottom} /></ErrorBoundaryProvider>);
}